<div *ngIf="loading" class="spinner">
  <mat-spinner></mat-spinner>
</div>

<div
  [hidden]="loading"
  class="card card-table"
  *ngIf="busLines.length > 0 && !loading"
>
  <div class="card-body">
    <header class="header">
      <h2 class="card-title">Linha de Ônibus x Casos</h2>
    </header>
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" class="mat-table-lines">
        <ng-container matColumnDef="line">
          <th mat-header-cell *matHeaderCellDef>Linha</th>
          <td mat-cell *matCellDef="let element" (click)="openComplaintByBusLines(element.line)" style="cursor: pointer;">
            {{ element.line }}
          </td>
        </ng-container>
        <ng-container matColumnDef="case">
          <th mat-header-cell *matHeaderCellDef>Casos</th>
          <td mat-cell *matCellDef="let element">
            {{ element.cases }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <div class="d-md-flex align-items-center justify-content-end">
      <mat-paginator [pageSizeOptions]="[10, 15, 30]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</div>
